import { SET_PANEL, SET_MENU, SET_PAGE } from './mutation-types';

const actions = {
    setPanels ({ commit, dispatch, state }, panels){
        if(panels){
            for(let e=0, elen=panels.length; e<elen; e++){
                let panel = panels[e];
                if(panel.id){
                    dispatch('setPanel', panel);
                }
            }
        }
    },
    setPanel ({ commit, state }, {id, ...params}){
        commit(SET_PANEL, {id, ...params});
    },
    setMenu ({ commit}, {...params}){
        commit(SET_MENU, {...params});
    },
    setPage ({ commit}, {...params}){
        commit(SET_PAGE, {...params});
    },
};

export default actions;
